import ModalDialog from './ModalDialog';
import './ModalDialog.scss';

export default ModalDialog;
